import { StrictMode } from "react";
import ReactDOM from "react-dom";

import AudioPlayer from "./AudioPlayer";
import tracks from "./data";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <AudioPlayer tracks={tracks} />
  </StrictMode>,
  rootElement
);
